import { Injectable } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { chatSystems } from '@monsido/core/constants/general.constant';
import '@client/app/modules/chat/forethought/forethought.types';

declare global {
    interface Window {
        Intercom?: (command: string, ...args: unknown[]) => void;
        Velaro?: { Engagement?: { ToggleInline: () => void } };
        zE?: (widget: string, action: string) => void;
    }
}

interface ChatSystemOptions {
    key?: string;
    settings?: string;
}

interface ChatSystem {
    system: string;
    options?: ChatSystemOptions;
    entire_env?: boolean;
    reseller?: number;
}

@Injectable({
    providedIn: 'root',
})
export class ActiveChatService {
    private activeSystemName: ChatSystem = { system: 'none' };

    constructor (
        private sessionService: SessionService,
    ) {
        this.sessionService.customer$.subscribe((customer) => {
            if (customer) {
                this.activeSystemName = this.computeActiveChat();
            } else {
                this.activeSystemName = { system: 'none' };
            }
        });
    }

    private computeActiveChat (): ChatSystem {
        const intercomId = chatSystems.intercom.intercomId;
        let activeSystem: ChatSystem = {
            system: 'intercom',
        };

        const selectedServer = this.sessionService.getSelectedServer();
        for (const [key, value] of Object.entries(chatSystems.environments)) {
            if (key === selectedServer) {
                for (const envConfig of value as ChatSystem[]) {
                    if (envConfig.entire_env === true) {
                        activeSystem = envConfig as ChatSystem;
                    } else if (this.sessionService.customer && envConfig.reseller === this.sessionService.customer.reseller.id) {
                        activeSystem = envConfig as ChatSystem;
                    }
                }
            }
        }

        if (activeSystem.system === 'intercom') {
            if (!(intercomId !== undefined && intercomId !== null && intercomId !== '')) {
                activeSystem = { system: 'none' };
            }
        }
        return activeSystem;
    }

    getActiveChat (): ChatSystem {
        return this.activeSystemName;
    }

    openChat (): void {
        const system = this.activeSystemName.system;

        if (system === 'forethought' && typeof window.Forethought === 'function') {
            window.Forethought('widget', 'show');
            window.Forethought('widget', 'open');
        } else if (system === 'intercom' && typeof window.Intercom === 'function') {
            window.Intercom('show');
        } else if (system === 'velaro' && window.Velaro?.Engagement) {
            window.Velaro.Engagement.ToggleInline();
        } else if (system === 'zendesk' && typeof window.zE === 'function') {
            window.zE('messenger', 'show');
            window.zE('messenger', 'open');
        }
    }
}
